import { BaseUrl } from './base_url_enum'
import Api from './retryApi'
import { ILoginApiResponse, ILoginApiSuccessResponse } from './types/login_api'

type RefreshTokenRequest = Promise<ILoginApiResponse<ILoginApiSuccessResponse>>

const inFlightRefreshes = new Map<string, RefreshTokenRequest>()

const requestRefreshToken = (
  refresh_token: string
): RefreshTokenRequest => Api('POST', 'refresh-token', BaseUrl.Login, {
  refresh_token
})

export const refreshTokenOnce = (
  refreshToken: string
): RefreshTokenRequest => {
  const inFlightRefresh = inFlightRefreshes.get(refreshToken)

  if (inFlightRefresh) {
    return inFlightRefresh
  }

  const request = requestRefreshToken(refreshToken).finally(() => {
    if (inFlightRefreshes.get(refreshToken) === request) {
      inFlightRefreshes.delete(refreshToken)
    }
  })

  inFlightRefreshes.set(refreshToken, request)

  return request
}
